import React from "react";
import { FormattedMessage } from "react-intl";
import cx from "classnames";
import s from "./Advantages.module.scss";
import { useSelector } from 'react-redux';
import { animated } from 'react-spring';
import { useBlockAnimate } from '@/shared/hooks/useBlockAnimate';
import { useNavigation } from '@/processes/Router';
import { useThreshold } from '@/processes/PoolStats'
import { selectPayoutAt } from '@/processes/PoolStats/poolStats.selectors'

type AdvantagesSecondProps = {
  className?: string;
}

const titleStyle = 'theme-text-highlight shadow text-3xl leading-[34px] sm:text-[38px] sm:leading-[54px] font-bold';
const descStyle = 'font-semibold mt-4 text-xl leading-6 sm:text-xl sm:leading-[26px]';

export const AdvantagesSecond = (props: AdvantagesSecondProps) => {
  const { className } = props;

  const { ref: ref1, springStyles: springTitleStyles1 } = useBlockAnimate({ intersect: true, delay: 200, top: 25, once: true });
  const { ref: ref2, springStyles: springTitleStyles2 } = useBlockAnimate({ intersect: true, delay: 200, top: 25, once: true });
  const { ref: ref4, springStyles: springTitleStyles4 } = useBlockAnimate({ intersect: true, delay: 200, top: 25, once: true });

  return (
    <div className={cx(s.root, className)} ref={ref1}>
      <animated.h2 className="landing-title" style={springTitleStyles1}>
        <FormattedMessage id="l.btc.adv2.t" values={{ br: <br/>, span: (...chunks) => <span className="theme-text-highlight">{chunks}</span>, }} />
      </animated.h2>
      <div className={s.blocks}>
        <span className={cx(s.abstract1, '-left-80 -top-36')} aria-hidden={true}/>
        <span className={cx(s.abstract1, '-right-52 -bottom-36')} aria-hidden={true}/>
        
        <span className={cx(s.abstract2, '-top-10 left-0 right-0 mx-auto')} aria-hidden={true}/>
        <span className={cx(s.abstract2, '-bottom-4 left-0 right-0 mx-auto transform rotate-180')} aria-hidden={true}/>
        <span className={cx(s.abstract2, '-left-44 -ml-2.5 top-0 bottom-0 my-auto transform -rotate-90')} aria-hidden={true}/>
        <span className={cx(s.abstract2, '-right-44 -mr-2.5 top-0 bottom-0 my-auto transform rotate-90')} aria-hidden={true}/>
       
        <animated.div ref={ref2} style={springTitleStyles2} className={s.blocksGrid}>
          <div className={s.blocksCol}>
            <div className={cx(s.blockWrap, s.blockmHLang)}>
              <div className={cx(s.block)}>
                <span
                  className={cx(titleStyle)}
                >
                  <FormattedMessage id="l.btc.adv2.b1.t" />{' '}
                </span>
                <span className={cx(descStyle)}>
                  <FormattedMessage id="l.btc.adv2.b1.d"/>
                </span>
              </div>
            </div>

          </div>
          <div className={s.blocksCol}>
            <div className={cx(s.blockWrap, s.blockmHLang)}>
              <div className={cx(s.block)}>
                <span className={cx(
                    titleStyle
                  )}
                >
                  <FormattedMessage id="l.btc.adv2.b2.t" />
                </span>
                <span className={cx(descStyle)}>
                  <FormattedMessage id="l.btc.adv2.b2.d" />
                </span>
              </div>
            </div>
          </div>
        </animated.div>

        <animated.div ref={ref4} style={springTitleStyles4} className={s.blocksGrid}>
          <div className={s.blocksCol}>
            <div className={cx(s.blockWrap, s.blockmHLang)}>
              <div className={cx(s.block)}>
                <span
                  className={cx(titleStyle)}
                >
                  <FormattedMessage id="l.btc.adv2.b3.t" />{' '}
                </span>
                <span className={cx(descStyle)}>
                  <FormattedMessage id="l.btc.adv2.b3.d" />
                </span>
              </div>
            </div>
          </div>

          <div className={s.blocksCol}>
            <div className={cx(s.blockWrap, s.blockmHLang)}>
              <div className={cx(s.block)}>
                <span
                  className={cx(titleStyle)}
                >
                  <FormattedMessage id="l.btc.adv2.b4.t" />{' '}
                </span>
                <span className={cx(descStyle)}>
                  <FormattedMessage id="l.btc.adv2.b4.d" />
                </span>
              </div>
            </div>
          </div>
        </animated.div>

      </div>
    </div>
  );
};

export default AdvantagesSecond;
